export default __webpack_public_path__ + "static/media/SEC0222.34I-38367_-25111_0.4f98c31c.jpg";